import { Strategy } from 'utility-ts-strategy';
import { ConditionalStrategy } from 'utility-ts-strategy';
import { IPlanFeedbackCourse, PlanFeedbackCourse } from '../builders/plan_feedback_course_builder';
import { IPlanFeedbackCourseGroup, PlanFeedbackCourseGroup } from '../builders/plan_feedback_course_group_builder';
import { PlanFeedbackProgramSlot } from '../builders/plan_feedback_program_slot_builder';
import {
  IPlanFeedbackSuggestion,
  planFeedbackTransactionType,
  TTermRelatedFeedbackDatasource
} from '../builders/plan_feedback_transaction_type';
import { IPlanFeebackCourseGroupsDatasource } from '../datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../datasources/plan_feedback_courses_datasource';
import { PlanFeedbackServant } from '../servants/plan_feedback_servant';
import { IFeedbackPossibleDataSource } from './../builders/plan_feedback_transaction_type';

// for better TS return indication
// using the function overloading
function processMoveTransactionTypeSuggestion(suggestion: IPlanFeedbackCourseGroup): IPlanFeedbackCourseGroup[];

function processMoveTransactionTypeSuggestion(suggestion: IPlanFeedbackCourse): IPlanFeedbackCourse[];

function processMoveTransactionTypeSuggestion(suggestion: IPlanFeedbackSuggestion): IPlanFeedbackSuggestion[] {
  return [
    {
      ...suggestion,
      diff: 'REMOVE',
      from_term: suggestion.from_term,
      term: undefined
    },
    {
      ...suggestion,
      diff: 'ADD',
      from_term: undefined,
      term: suggestion.term
    }
  ];
}

export const PlanFeedbackSuggestionsForTransactionTypeConditionalStrategy = new Strategy({
  ADD: (suggestion: IPlanFeedbackSuggestion): IPlanFeedbackSuggestion[] => [suggestion],
  REMOVE: (suggestion: IPlanFeedbackSuggestion): IPlanFeedbackSuggestion[] => [suggestion],
  NONE: (suggestion: IPlanFeedbackSuggestion): IPlanFeedbackSuggestion[] => [suggestion],
  MOVE: processMoveTransactionTypeSuggestion
});

export const PlanFeedbackTermFieldIdentifierStrategy = new Strategy({
  MOVE: {
    validTermFields: ['from_term', 'term'],
    currentTermField: 'from_term'
  },
  ADD: {
    validTermFields: ['term'],
    currentTermField: 'term'
  },
  REMOVE: {
    validTermFields: ['from_term'],
    currentTermField: 'from_term'
  },
  NONE: {
    validTermFields: ['from_term', 'term'],
    currentTermField: 'term'
  }
});

const updateToNoneSuggestion = (
  suggestion: PlanFeedbackCourseGroup | PlanFeedbackCourse,
  dataSource: TTermRelatedFeedbackDatasource
) => {
  const suggestionInDataSource = dataSource.get(suggestion.id);
  if (!suggestionInDataSource) {
    console.warn(`tried to access suggestion that doesn't exist in datasource`);
    return;
  }
  suggestionInDataSource.diff = 'NONE';
  suggestionInDataSource.term = suggestionInDataSource.from_term;
  suggestionInDataSource.lock_modified = false;
  suggestionInDataSource.from_comment = suggestionInDataSource.comment;
  dataSource.put(suggestionInDataSource);
};

export const APPlanFeedbackDataSourceUpdateAfterDeclineStrategy = new Strategy({
  ADD: (suggestion: PlanFeedbackCourseGroup | PlanFeedbackCourse, dataSource: TTermRelatedFeedbackDatasource) =>
    dataSource.del(suggestion.id),
  REMOVE: updateToNoneSuggestion,
  MOVE: (suggestion: PlanFeedbackCourseGroup | PlanFeedbackCourse, dataSource: TTermRelatedFeedbackDatasource) => {
    const suggestionInDataSource = dataSource.get(suggestion.id);
    if (!suggestionInDataSource) {
      console.warn(`tried to access suggestion that doesn't exist in datasource`);
      return;
    }
    suggestionInDataSource.diff = 'NONE';
    suggestionInDataSource.term = suggestionInDataSource.from_term;
    suggestionInDataSource.from_term = null;
    suggestionInDataSource.lock_modified = false;
    suggestionInDataSource.from_comment = suggestionInDataSource.comment;
    dataSource.put(suggestionInDataSource);
  }
});

export const updateToProgramSlotTransaction = (
  suggestion: PlanFeedbackProgramSlot,
  dataSource: TTermRelatedFeedbackDatasource
) => dataSource.del(suggestion.id);

export const APPlanFeedbackDataSourceUpdateAfterAcceptStrategy = new Strategy({
  NONE: updateToNoneSuggestion,
  ADD: updateToNoneSuggestion,
  MET: updateToProgramSlotTransaction,
  UNMET: updateToProgramSlotTransaction,
  REMOVE: (suggestion: PlanFeedbackCourseGroup | PlanFeedbackCourse, dataSource: TTermRelatedFeedbackDatasource) =>
    dataSource.del(suggestion.id),
  MOVE: (suggestion: PlanFeedbackCourseGroup | PlanFeedbackCourse, dataSource: TTermRelatedFeedbackDatasource) => {
    const suggestionInDataSource = dataSource.get(suggestion.id);
    if (!suggestionInDataSource) {
      console.warn(`tried to access suggestion that doesn't exist in datasource`);
      return;
    }
    suggestionInDataSource.diff = 'NONE';
    suggestionInDataSource.from_term = null;
    suggestionInDataSource.lock_modified = false;
    suggestionInDataSource.from_comment = suggestionInDataSource.comment;
    dataSource.put(suggestionInDataSource);
  }
});

export const APPlanFeedbackDataSourceUpdateAfterAcceptDeclineStrategy = new Strategy({
  REJECT: (suggestion: IPlanFeedbackSuggestion, dataSource: IFeedbackPossibleDataSource) =>
    APPlanFeedbackDataSourceUpdateAfterDeclineStrategy[suggestion.diff](suggestion, dataSource),
  ACCEPT: (suggestion: IPlanFeedbackSuggestion, dataSource: IFeedbackPossibleDataSource) =>
    APPlanFeedbackDataSourceUpdateAfterAcceptStrategy[suggestion.diff](suggestion, dataSource)
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/strategies/plan_feedback_transaction_types_query_strategy.ts